module.exports = {
	catagory: "legal specifications",
	defaultImage: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80",
	questions: [
		{
			questionText: `In what country is Darjeeling tea produced?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`India`,
				],
				incorrect: [
					`Japan`,
					`Sri Lanka`,
					`Ceylon`,
					`China`,
				]
			},
			response: `The India Tea Board has held a United States trademark for Darjeeling tea since 1988.
			    “The certification mark, as used by persons authorized by certifier, certifies that a blend of tea contains at least one hundred percent (100%) tea originating in the Darjeeling region of India, and that the blend meets other specifications established by the certifier.”
			    `,
			tags: ["darjeeling"],
			citations: `http://teaboard.gov.in/pdf/policy/USA.pdf`,
			image: ``
		},
		{
			questionText: `In what country is Ceylon tea produced?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Sri Lanka`,
				],
				incorrect: [
					`India`,
					`Ceylon`,
					`China`,
					`Japan`,
				]
			},
			response: `The Sri Lanka tea board holds United States trademarks for Ceylon Tea, Ozone Friendly Pure Ceylon Tea, and Ceylon Tea Symbol Of Quality.`,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `In what country is Pu'er tea produced?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
					`India`,
					`Sri Lanka`,
					`Ceylon`,
					`China`,
					`Japan`,
				]
			},
			response: `The Yunnan Province Pu’er Tea Association holds a United States trademark for Puer.

    “The certification mark, as intended to be used by persons authorized by the certifier, is intended to certify that the goods provided have met the following criteria of origin, quality, and processing methods: Pu’er tea (raw tea) is to be made from fresh leaves from Yunnan big leaf tea trees growing in conditions suitable for Pu’er. It is compressed tea made by the deactivation of enzymes, twisting, drying by sunshine, and shaping by steaming, compressing and other processes. The characteristics are: dark green color, fresh and long-lasting fragrance, sweet and dense taste, green-yellow, bright liquor, and green–yellow, thick leaves. Pu’er tea (cooked tea) is made of dried green tea leaves from Yunnan big leaf tea trees growing in conditions suitable for Pu’er. Its loose tea and compressed tea are made by special process and post-fermentation (fast or slow post-fermentation). The characteristics are: red-brown color, dense, bright red liquor color, a special fragrance, sweet and dense taste, and red-brown leaves.”`,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `Which country holds the trademark for LongJing`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Zhejiang Agriculture Department`,
				],
				incorrect: [
					`Yunnan Agriculture Department`,
					`Guangzhou Agriculture Department`,
					`Beijing Agriculture Department`,
					`Fujian Agriculture Department`,
				]
			},
			response: `The Zhejiang Agriculture Department holds a United States trademark that limits the use of the name "Long Jing" in o teas produced in Hangzhou City West Lake District (West Lake Scenic Area), Xiaoshan District, Binjiang District, Yuhang District, Fuyang City, Linan City, Tonglu County Jiande City, Chunan County, Shaoxing County, Xinchang County, Shengzhou City, Zhuji City, Shangyu City, Yuecheng District, Panan County, Dongyang City, and Tiantai County.`,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `What is an appellation?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`A legally defined and protected geographical indication.`,
				],
				incorrect: [
					``,
					``,
					``,
					``,
				]
			},
			response: ``,
			tags: ["https://en.wikipedia.org/wiki/Appellation"],
			citations: ``,
			image: ``
		},
		{
			questionText: `What is a geographical indication (GI)`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`A name or sign used to indicate specific geographical location.`,
				],
				incorrect: [
					``,
					``,
					``,
					``,
				]
			},
			response: ``,
			tags: [""],
			citations: `https://en.wikipedia.org/wiki/Geographical_indication`,
			image: ``
		},
		{
			questionText: `What are the numbers prefixed by “GB”`, 
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Code for mandatory Guobiao (国标; GB) standards.`,
				],
				incorrect: [
					``,
					``,
					``,
					``,
				]
			},
			response: ``,
			tags: [""],
			citations: `https://en.wikipedia.org/wiki/Guobiao_standards`,
			image: ``
		},
		{
			questionText: `What are the numbers prefixed by “GB/T” `,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Code for recommended (推荐; T) Guobiao (国标; GB) standards.`,
				],
				incorrect: [
					``,
					``,
					``,
					``,
				]
			},
			response: ``,

			tags: [""],
			citations: `https://en.wikipedia.org/wiki/Guobiao_standards`,
			image: ``
		},
		{
			questionText: `What Country uses the QS mark?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`China`,
				],
				incorrect: [
					``,
					``,
					``,
					``,
				]
			},
			response: `The QS mark (生产许可) is managed by the General Administration of Quality Supervision, Inspection and Quarantine (AQSIQ).`,
			tags: [""],
			citations: `https://en.wikipedia.org/wiki/QS_mark`,
			image: ``
		},

		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Sabaragamuwa`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Nuwara-Eliya`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Dimbula`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Ruhuna`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Uva`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Uda Pussellawa`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
		{
			questionText: `The Sri Lanka tea board holds trademarks for the following growing regions:`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					`Kandy`,
				],
				incorrect: [
					`Darjeeling`,
					`Assam`,
					`Nilgiri`,
					`Kagoshima`,
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
	]
}